<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<h6 class="prd-h6"> Demo Settings - Modify User Role </h6>
<div class="card" >
    <div class="card-body" *ngIf = 'displayState.workingDiv'>
        <div class="row" >
            <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
        </div>
        <div class="row">
            <div class="col-md-2 offset-5">
                <!-- <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner> -->
            </div>
        </div>
    </div>
</div>
<br />
<div class="card bg-light col-md-6 offset-3">
    <div class="card-body">
        <div class="row">
            <label for="userType" class="col-md-2 col-form-label prd-label">Current Role</label>
            <div class="col-md-1">
                <select [(ngModel)] = 'myRole' id="userType" name="userType" class="prd-required">
                    <option></option>
                    <option [ngValue]="usrType" *ngFor="let usrType of userTypeList" >{{ usrType }}</option>
                </select>
            </div>
        </div>
        <br />
        <div class="row">
                <!-- Buttons -->
                <button class="btn btn-success offset-1" (click)="saveRole()" >Save</button>
                <button class="btn btn-warning offset-1" (click)="cancelEntry()">Cancel</button>
                <button class="btn btn-warning offset-1" (click)="clearLocalStore()">Clear Last Applicant/Agency</button>
                <button class="btn btn-warning offset-1" (click)="checkDBConn()">Check SB DB connection</button>
        </div>
    </div>
</div>
